module.exports = __webpack_public_path__ + "4f82ea102ab496e53e6148d65423a8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jingjiguancha_c.png
// module id = 294
// module chunks = 3